(function () {
    let count = 1;
    const casestudyListingWrap = document.querySelector('.case-studies-listings .row');
    let dataTax = '';
    let dataSlug = '';
    const casestudyIndustriesTaxLists = document.querySelectorAll('.casestudy-industries-taxonomy-tab ul li button');
    let currentscrollHeight = 0;
    let scrolled = false;
    if(casestudyListingWrap){
        casestudyIndustriesTaxLists.forEach(element => {
            element.addEventListener('click',function(){
                casestudyIndustriesTaxLists.forEach(item=>{
                    item.classList.remove('active');
                });
                count = 1;
                scrolled = false;
                element.classList.add('active');
                dataTax = element.getAttribute('data-tax');
                dataSlug = element.getAttribute('data-slug');
                currentscrollHeight = 0;
                filterCaseStudy(dataTax,dataSlug,count,scrolled);
                casestudyListingWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
            })
        });

        window.addEventListener("scroll", function() {
            let scrollHeight = document.body.scrollHeight;
            let footerHeight = document.querySelector(".site-footer-top").offsetHeight;
            let scrollPos = Math.floor(window.innerHeight + window.scrollY);
            let isBottom = scrollHeight - footerHeight < scrollPos;
            const activeElement = document.querySelector(".casestudy-industries-taxonomy-tab ul li button.active")
            let activeElementDataTax = '';
            let activeElementDataSlug = '';
            if(activeElement){
                activeElementDataTax = activeElement.getAttribute('data-tax');
                activeElementDataSlug = activeElement.getAttribute('data-slug');
            }
            if (isBottom && currentscrollHeight < scrollHeight) {
                scrolled = true;
                count++;
                currentscrollHeight = scrollHeight;
                filterCaseStudy(activeElementDataTax,activeElementDataSlug,count,scrolled);
            }
        });

        // Filter Case Study Function
        function filterCaseStudy(dataTax = '',dataSlug = '',page='',scrolled='') {
            const maxPages = document.querySelector("#maxnumpages");
            if(maxPages){
                if(page <= maxPages.value){
                    casestudyListingWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
                }
            }
            let filterData = "";
            filterData = "&taxonomy=" + dataTax;
            filterData +="&slug=" + dataSlug;
            filterData +="&page="+page;
            // Ajax request
            let request = new XMLHttpRequest();
            request.open("POST", metz_ajax_callback_data.ajax_url, true);
            request.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
            );
            
            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    const loadMoreGif = document.querySelector("#loading");
                    if(loadMoreGif){
                        loadMoreGif.remove();
                    }
                    const responseData = JSON.parse(request.response);
                    if(maxPages){
                        maxPages.value = responseData.data.max_num_pages;
                    }
                    if (responseData.data.output === 'no-items') {
                        responseHtml = '<span class="no-result">No Results Found</span>';
                    }
                    else {
                        responseHtml = responseData.data.output;
                        let foundPost = responseData.data.foundPost;
                    }
                    if(scrolled == true){
                        if(responseData.data.output != 'no-items' && casestudyListingWrap){
                            casestudyListingWrap.innerHTML += responseHtml;
                        }
                    }else{
                        casestudyListingWrap.innerHTML = responseHtml;
                    }
                }
            };
            request.send(
            "action=casestudylistings&nonce=" +
                metz_ajax_callback_data.ajax_nonce +
                filterData
            );
        }
    }
})();